export class TixxConnect {
  public username?: string;
  public password?: string;
  public client?: string;

  public constructor(tixxConnect?: any) {
    this.username = tixxConnect?.username;
    this.password = tixxConnect?.password;
    this.client = tixxConnect?.client;
  }
}

export class TixxConnection {
  public client: string;
  public username: string;
  public password: string;
  public url: string;
  public xmlContent: string;

  constructor(connectionData: any) {
    this.client = connectionData.client;
    this.username = connectionData.user;
    this.password = connectionData.pw;
    this.xmlContent = connectionData.xml_content;
    this.url = connectionData.url;
  }
}

export class TixxConnectionProvider {
  open: boolean;
  bankAccountId: number;
  reservationId: string;
}
